import { useState, useMemo, useCallback } from 'react';
import { Offer, SelectedOffer } from './types';
import { getOfferStatus } from './utils';

export const useOffers = (offers: Offer[]) => {
  const [selectedOffer, setSelectedOffer] = useState<SelectedOffer | null>(null);
  const [showExpiredOffers, setShowExpiredOffers] = useState(false);
  const [isExpanding, setIsExpanding] = useState(false);
  const [isCollapsing, setIsCollapsing] = useState(false);

  const availableOffers = useMemo(
    () => offers.filter(offer => getOfferStatus(offer) === 'available'),
    [offers]
  );

  const expiredOffers = useMemo(
    () => offers.filter(offer => getOfferStatus(offer) === 'expired'),
    [offers]
  );

  const handleExpand = useCallback(() => {
    setIsExpanding(true);
    setTimeout(() => {
      setShowExpiredOffers(true);
      setIsExpanding(false);
    }, 100);
  }, []);

  const handleCollapse = useCallback(() => {
    setIsCollapsing(true);
    setTimeout(() => {
      setShowExpiredOffers(false);
      setIsCollapsing(false);
    }, 400);
  }, []);

  const handleSelectOffer = useCallback((offer: Offer, defaultTitle: string) => {
    if (getOfferStatus(offer) === 'available' && offer.offerNumber) {
      setSelectedOffer({
        offerNumber: offer.offerNumber,
        offerName: offer.offerName || defaultTitle,
        endDate: offer.endDate
      });
    }
  }, []);

  const handleCloseDialog = useCallback(() => {
    setSelectedOffer(null);
  }, []);

  return {
    availableOffers,
    expiredOffers,
    selectedOffer,
    showExpiredOffers,
    isExpanding,
    isCollapsing,
    handleExpand,
    handleCollapse,
    handleSelectOffer,
    handleCloseDialog,
  };
};
